import React from "react";

function SVG() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="469.769" height="726.748"><switch><g><path fill="#E5002E" d="M332.838 0L161.771 99.336 0 193.301l91.269 32.344-15.898 501.103 303.13-399.318 91.268 32.341-66.286-174.144z" /></g></switch></svg>
    );
}

export default SVG;
